export const reducer = (state, action) => {
  return { ...state, ...action };
};

export const initialState = {};
